import React, { useEffect } from 'react';
import { useLottieAnimation } from '@leagueplatform/lottie';
import { usePrefersReducedMotion } from '@leagueplatform/web-common';
import { Box } from '@leagueplatform/genesis-core';
import { RewardsAnimationComponentProps } from '#constants/types.ts';

const animationData = import('#assets/celebration-confetti.lottie.json');

export default function CelebrationConfettiAnimation({
  animationRef,
  lottieConfig: configOverrides,
  shouldPlay,
}: RewardsAnimationComponentProps) {
  const prefersReducedMotion = usePrefersReducedMotion();

  const lottieConfig = {
    loop: false,
    autoplay: shouldPlay,
    ...configOverrides,
  };
  const { animationContainerRef, animation } = useLottieAnimation({
    lottieConfig,
    animationRef,
    animationData,
  });

  useEffect(() => {
    if (shouldPlay) {
      animation?.goToAndPlay(0);
    }
  }, [shouldPlay, animation]);

  return prefersReducedMotion ? null : (
    <Box css={{ opacity: shouldPlay ? 1 : 0 }} ref={animationContainerRef} />
  );
}
